module.exports = __webpack_public_path__ + "media/vendor/leap/pages/assets/img/icons/theme/media/eject-bc3659623f646c748519ec6ad84f4520.svg";